import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './SubHeader.scss';
import { TLocalesKeys } from '../../../types';

type SubHeaderProps = {
  dataHook: string;
};

export const SubHeader: FC<SubHeaderProps> = ({ dataHook }) => {
  const { t } = useTranslation();

  return (
    <div className={s.root} data-hook={dataHook}>
      <h2>{t<TLocalesKeys>('subheader_title')}</h2>
      <div className={s.headline}>{t<TLocalesKeys>('subheader_headline')}</div>
    </div>
  );
};
